import React, { Component } from "react"

export default class AbuMoola extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">AbuMoola</p>
            <p className="portdesctext">Small script to organise financing & contacts.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://github.com/ternlef11/AbuMoola" target="_blank" rel="noopener noreferrer"><p className="linktext">Repo</p></a>
        </div>
      </div>
  )
}
}

